module.exports = __webpack_public_path__ + "img/图像 1@2x.67173bb1.webp";